export enum ValidatedAttachmentType {
    ForgottenAttachments,
    PendingPermissions,
    SharingIssue,
}
